import PropTypes from "prop-types";
import React from "react";
import { Typography, Button, Box } from "@mui/material";
import Modal from "../Modal/Modal";
import { useTranslation } from "react-i18next";

const ProcessFileModal = ({ uploadVideo, onClose, open }) => {
  const { t } = useTranslation();

  return (
    <>
      <Modal
        disableEnforceFocus
        showCloseIcon
        maxWidth="sm"
        fullWidth
        dialogTitle={
          <Typography variant="h4" color="textPrimary">
            {t("videoProcessing.modalTitle")}
          </Typography>
        }
        dialogContent={
          <Box display="flex" flexDirection="column" mb={1}>
            {t("videoProcessing.modalDescription")}
          </Box>
        }
        dialogActions={
          <>
            <Button color="primary" onClick={onClose}>
              {t("videoProcessing.cancel")}
            </Button>
            <Button variant="contained" color="primary" onClick={uploadVideo}>
              {t("videoProcessing.upload")}
            </Button>
          </>
        }
        open={open}
        onClose={onClose}
      />
    </>
  );
};

ProcessFileModal.propTypes = {
  /**
   * Called to close the Modal
   */
  onClose: PropTypes.func,
  /**
   * True if the modal is open, false otherwise
   */
  open: PropTypes.bool,
  /**
   * Called when the form is submitted to upload the new file
   */
  uploadFile: PropTypes.func
};

export default ProcessFileModal;
